var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttempt2Badge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 18,
    rx: 7.5,
    stroke: "#3260D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.548 14C8.372 14 8.24 13.96 8.152 13.88C8.072 13.792 8.032 13.676 8.032 13.532C8.032 13.444 8.052 13.36 8.092 13.28C8.14 13.192 8.204 13.104 8.284 13.016L10.972 10.136C11.38 9.696 11.672 9.292 11.848 8.924C12.032 8.548 12.124 8.168 12.124 7.784C12.124 7.304 11.976 6.94 11.68 6.692C11.392 6.436 10.968 6.308 10.408 6.308C10.048 6.308 9.708 6.364 9.388 6.476C9.068 6.588 8.76 6.76 8.464 6.992C8.36 7.072 8.264 7.108 8.176 7.1C8.096 7.092 8.024 7.06 7.96 7.004C7.896 6.948 7.852 6.876 7.828 6.788C7.804 6.7 7.804 6.612 7.828 6.524C7.86 6.436 7.924 6.356 8.02 6.284C8.332 6.028 8.708 5.824 9.148 5.672C9.588 5.512 10.036 5.432 10.492 5.432C11.06 5.432 11.54 5.52 11.932 5.696C12.324 5.872 12.62 6.132 12.82 6.476C13.02 6.812 13.12 7.224 13.12 7.712C13.12 8.048 13.064 8.38 12.952 8.708C12.848 9.028 12.684 9.356 12.46 9.692C12.244 10.028 11.96 10.376 11.608 10.736L9.052 13.436V13.16H13.096C13.248 13.16 13.36 13.196 13.432 13.268C13.512 13.332 13.552 13.432 13.552 13.568C13.552 13.712 13.512 13.82 13.432 13.892C13.36 13.964 13.248 14 13.096 14H8.548Z",
    fill: "#3260D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempt2Badge);
export default __webpack_public_path__ + "static/media/attempt-2-badge.fed7c27a6cbc32bf9da8ab523fb75048.svg";
export { ForwardRef as ReactComponent };